module.exports = __webpack_public_path__ + "img/Slice 268@2x(9).398a1596.png";